import { UmbracoTypes } from '~/lib/data-contract';
import { useRelatedResults } from '~/services/loop54/hooks';
import { memo } from 'react';
import { CarouselWithItems } from './helpers';

function M30RelatedProductCarousel({
    headline,
    productId,
}: Omit<UmbracoTypes.IM30RelatedProductCarouselModule, 'type'>) {
    const { data } = useRelatedResults(productId);

    return <CarouselWithItems data={data?.results?.items} headline={headline} />;
}

export default memo(M30RelatedProductCarousel);
